// -----------------------------------------------------------
// @ ExpenseStatus Actions
// -----------------------------------------------------------

import { createAction, props } from '@ngrx/store';
import { ExpenseStatus } from './expense-status.models';

// Load all Expense Status
export const loadAllExpenseStatus = createAction(
    '[ExpenseStatus] Load All Expense Status'
);
export const loadAllExpenseStatusSuccess = createAction(
    '[ExpenseStatus] Load All Expense Status Success',
    props<{ status: ExpenseStatus[] }>()
);
export const loadAllExpenseStatusFailure = createAction(
    '[ExpenseStatus] Load All Expense Status Failure',
    props<{ error: string }>()
);

// Load single Expense Status
export const loadExpenseStatus = createAction(
    '[ExpenseStatus] Load Expense Status',
    props<{ id: number }>()
);
export const loadExpenseStatusSuccess = createAction(
    '[ExpenseStatus] Load Expense Status Success',
    props<{ status: any }>()
);
export const loadExpenseStatusFailure = createAction(
    '[ExpenseStatus] Load Expense Status Failure',
    props<{ error: string }>()
);

// Create
export const createExpenseStatus = createAction(
    '[ExpenseStatus] Create Expense Status',
    props<{ data: string }>()
);
export const createExpenseStatusSuccess = createAction(
    '[ExpenseStatus] Create Expense Status Success',
    props<{ status: any; success: string }>()
);
export const createExpenseStatusFailure = createAction(
    '[ExpenseStatus] Create Expense Status Failure',
    props<{ error: string }>()
);

// Update
export const updateExpenseStatus = createAction(
    '[ExpenseStatus] Update Expense Status',
    props<{ data: string; id: number }>()
);
export const updateExpenseStatusSuccess = createAction(
    '[ExpenseStatus] Update Expense Status Success',
    props<{ status: any; success: string }>()
);
export const updateExpenseStatusFailure = createAction(
    '[ExpenseStatus] Update Expense Status Failure',
    props<{ error: string }>()
);

// Delete
export const deleteExpenseStatus = createAction(
    '[ExpenseStatus] Delete Expense Status',
    props<{ id: number }>()
);
export const deleteExpenseStatusSuccess = createAction(
    '[ExpenseStatus] Delete Expense Status Success',
    props<{ id: number; success: string }>()
);
export const deleteExpenseStatusFailure = createAction(
    '[ExpenseStatus] Delete Expense Status Failure',
    props<{ error: string }>()
);
